// extracted by mini-css-extract-plugin
export default {"organizationBox":"Organization_organizationBox__30kTg","logoSmall":"Organization_logoSmall__JeKgW"};